<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div class="row pl-4 pr-4" v-show="tela == 1">
            <h4 slot="header" class="card-title text-left m-0">
              RELATÓRIO RESUMO ANALÍTICO DE PONTO
            </h4>
            <BaseFiltroRelatorio
              class="col-sm-6 col-12"
              :filterBancoHora="true"
              :limitarData="true"
              @pesquisar="pesquisar"
              @enviarEmail="enviarEmail"
            />
            <div class="offset-sm-6 "></div>
          </div>

          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>

            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      {{ `RELATÓRIO RESUMO ANALÍTICO DE PONTO` }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                      ${moment(payloadPesquisa.data_final).format(
                        "DD/MM/YYYY",
                      )}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left" v-if="payloadPesquisa.bancoHora">
                      {{ `BANCO DE HORAS: SIM` }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `BANCO DE HORAS: NÃO` }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `TOTAL DE FUNCIONÁRIOS ENCONTRADOS: ${pagination.totalItems}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabela de Resultados-->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Faltas</th>
                    <th scope="col">Trabalhadas</th>
                    <th scope="col">Atrasos</th>
                    <th v-if="!calcularLabelBH()" scope="col">Extras 50%</th>
                    <th v-if="!calcularLabelBH()" scope="col">Extras 100%</th>
                    <th v-if="calcularLabelBH()" scope="col">B.H Inicial</th>
                    <th v-if="calcularLabelBH()" scope="col">B.H Crédito</th>
                    <th v-if="calcularLabelBH()" scope="col">B.H Débito</th>
                    <th v-if="calcularLabelBH()" scope="col">Saldo BH</th>
                    <th scope="col">A. Noturno</th>
                    <th scope="col">Abonos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dados" :key="item.cpf">
                    <th>
                      <p class="m-0 p-0">{{ item.empregado || `` }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.faltasDias }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.exercidas }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.atrasos }}</p>
                    </th>
                    <th v-if="!calcularLabelBH()">
                      <p class="m-0 p-0">{{ item.extras }}</p>
                    </th>
                    <th v-if="!calcularLabelBH()">
                      <p class="m-0 p-0">{{ item.extras100 }}</p>
                    </th>
                    <th v-if="calcularLabelBH()">
                      <p class="m-0 p-0">{{ item.bancoHora.labelInicial }}</p>
                    </th>
                    <th v-if="calcularLabelBH()">
                      <p class="m-0 p-0">{{ item.bancoHora.labelCredito }}</p>
                    </th>
                    <th v-if="calcularLabelBH()">
                      <p class="m-0 p-0">{{ item.bancoHora.labelDebito }}</p>
                    </th>
                    <th v-if="calcularLabelBH()">
                      <p class="m-0 p-0">{{ item.bancoHora.labelSaldo }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.noturno }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.abonos }}</p>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <Paginacao
              v-show="!printing"
              :currentPage="pagination.currentPage"
              :totalPages="pagination.totalPages"
              @page-changed="listarResumoAnalitico"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseInput,
  BaseFiltroRelatorio,
  Paginacao,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroRelatorio,
    Paginacao,
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        perPage: 50,
        totalItems: 0,
        totalPages: 0,
      },
      payloadPesquisa: Object,
      printing: false,
      isLoading: false,
      tela: 1, //1 filtros, 2 -resultados
      dados: [],
    };
  },
  methods: {
    calcularLabelBH() {
      //tratando quando tiver apenas 1 resultado, provavelmente pegou do filtro de nome
      if (this.dados.length == 1) {
        return this.dados[0].config.bancoHora ? true : false;
      } else {
        return this.payloadPesquisa.bancoHora ? true : false;
      }
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    solicitarResumoAnalitico() {
      let th = this;
      th.isLoading = true;
      const bodyFormData = {
        ...this.payloadPesquisa,
      };
      this.axios
        .post("/api/relatorio/solicitarResumoAnalitico", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (response.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Solicitação enviada com sucesso! Os dados serão enviados para o(s) email(s) inserido(s)",
              "success",
            );
            setTimeout(() => {
              location.reload();
            }, 3000);
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar relatório!",
            "error",
          );
        });
    },
    listarResumoAnalitico(page = 1) {
      let th = this;
      th.isLoading = true;
      const bodyFormData = {
        ...this.payloadPesquisa,
        page,
        limit: this.pagination.perPage,
      };
      this.axios
        .post("/api/relatorio/listarResumoAnalitico", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.dados = response.data.data.funcionarios;
            th.pagination = response.data.data.paginacao;
            th.tela = 2;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar relatório!",
            "error",
          );
        });
    },

    enviarEmail(event) {
      this.payloadPesquisa = event;
      this.solicitarResumoAnalitico();
    },
    pesquisar(event) {
      this.payloadPesquisa = event;
      this.listarResumoAnalitico(1);
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
  },
};
</script>
<style></style>
